import $ from 'jquery';

import '@claviska/jquery-minicolors';

import Vars from '../../vars'

import Action from "../classes/Action";

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';
import Validation from './../classes/Validation';

class Widget {
    constructor (args) {
        let self = this;

        self._setArgs(args);
        self._init();
    };

    _elems = {
        $content   : $(),
        $create    : $(),
        $edit      : $(),
        $params    : $(),
        $crmAttach : $(),
        $crmDetach : $(),

        $documentLinkAttach : $(),
        $documentLinkDetach : $()
    };

    _const = {
        entities : 'widgets',
        entity   : 'widget',
        id       : 'widget_id',
        title : {
            add  : 'Добавление нового виджета',
            edit : 'Редактирование виджета'
        }
    };

    _args = {
        mode   : '',
        prefix : '',
        suffix : ''
    };

    _state = {
        modal    : {},
        fields   : {},
        item     : {},
        items    : {},
        objects  : {},
        crms     : {},

        document_links : {}
    };

    _actions = {
        activate : {
            title: 'Активация виджета'
        },
        deactivate : {
            title: 'Деактивация виджета'
        },
        remove : {
            title: 'Удаление виджета'
        },
        confirmation : {
            title: 'этот виджет'
        },
        done : {
            activate : function(args) {
                let self = args.self;
                self._state.item = args[self._const.entity];

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Виджеты',
                            href  : '#widgets'
                        },
                        {
                            title : 'Виджет №' + self._state.item.widget_id
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.widget_id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            },
            deactivate : function(args) {
                let self = args.self;
                self._state.item = args[self._const.entity];

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Виджеты',
                            href  : '#widgets'
                        },
                        {
                            title : 'Виджет №' + self._state.item.widget_id
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.widget_id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            }
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.mode   = args.mode;
        self._args.title  = args.title;
        self._args.prefix = args.prefix;
        self._args.suffix = args.suffix;
    };_setFields = () => {
        let self = this;

        self._state.fields = {};
    };

    _setParamsFields = () => {
        let self = this;

        let documentLinks = [
            {
                name : 'Не указывать'
            }
        ]
        self._state.documentLinks.forEach(dl => {
            documentLinks[dl.id] = {
                name : dl.name
            }
        })

        self._state.paramsFields = {
            counters : {
                title : 'Счетчики',
                type  : 'group',
                items : {
                    yandex : {
                        title       : 'Яндекс.Метрика',
                        type        : 'string',
                        required    : false,
                        validation  : 'nullable,yandex.metrika',
                        value       : self._state.item.counters && 'yandex' in self._state.item.counters ? self._state.item.counters['yandex'] : null,
                        placeholder : '24562465'
                    },
                    google : {
                        title       : 'Google Analytics',
                        type        : 'string',
                        required    : false,
                        validation  : 'nullable,google.analytics',
                        value       : self._state.item.counters && 'google' in self._state.item.counters ? self._state.item.counters['google'] : null,
                        placeholder : 'UA-92342075-1'
                    },
                    facebook_pixel : {
                        title       : 'Facebook Pixel',
                        type        : 'string',
                        required    : false,
                        validation  : 'nullable,facebook.pixel',
                        value       : self._state.item.counters && 'facebook_pixel' in self._state.item.counters ? self._state.item.counters['facebook_pixel'] : null,
                        placeholder : '789446564154896'
                    },
                    vk_pixel : {
                        title       : 'ВКонтакте Pixel',
                        type        : 'string',
                        required    : false,
                        validation  : 'nullable',
                        value       : self._state.item.counters && 'vk_pixel' in self._state.item.counters ? self._state.item.counters['vk_pixel'] : null,
                        placeholder : 'VK-RTRG-13498765-32vio'
                    }
                }
            },
            documents : {
                title : 'Документы',
                type  : 'group',
                items : {
                    confidential : {
                        title   : 'Политика конфиденциальности',
                        type    : 'select',
                        options : documentLinks,
                        value   : self._state.item.document_link.length ? self._state.item.document_link[0].id : null,
                        description : 'Создать свою политику конфиденциальности можете в разделе "Регистрационная информация"'
                    }
                }
            }
        };
    };

    _initModal = () => {
        let self = this;

        self._setFields();

        loader.increase();

        let queue = [];
        if (Object.keys(self._state.item).length) {
            queue.push({
                path : '/api/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item.widget_id + '_view' : self._args.prefix + '_' + self._args.suffix)
            });
        }
        queue.push({
            path : '/api/' + self._const.entities + '/options'
        });

        Request.send({
            queue : queue,
            done : function(response, extraResponse) {
                loader.decrease();

                self._state.item = Object.keys(self._state.item).length ? response[self._const.entity] : {};

                const options       = Object.keys(self._state.item).length ? extraResponse.options : response.options;
                const objects       = Object.keys(options).length && options.objects ? options.objects : [];
                const objectsShared = options.objects_shared;

                self._state.objects = objects.concat(objectsShared);

                if (!Object.keys(self._state.objects).length) {
                    new Modal({
                        title: 'Сообщение',
                        content: Utils.renderProfileTemplate('warning', {
                            warning : {
                                text : 'Для выполнения операции необходимо добавить хотя бы один комплекс'
                            }
                        }),
                        confirm : function(args) {
                            args.modal && args.modal.trigger('close');
                        }
                    });

                    return;
                }

                self._state.modal = new Modal({
                    title : self._state.item ? self._const.title.edit : self._const.title.add,
                    closingConfirmation : true,
                    confirm : function(args){
                        self._bindSubmit(args);
                    },
                    content: Utils.renderProfileTemplate(self._const.entity + '-form', {
                        [self._const.entity] : self._state.item,
                        fields               : self._state.fields,

                        objects              : self._state.objects,
                        parts                : options.parts,
                        templates            : options.templates,
                        colors               : options.colors,
                        companies            : options.companies,
                        values               : response.values ? response.values : {},
                        buttons  : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Сохранить',
                                type  : 'submit'
                            },
                            two : {
                                class : 'button--cancel',
                                title : 'Отмена'
                            }
                        }
                    })
                });

                self._bindFormActions();
            }
        });
    };

    _initParams = () => {
        let self = this;

        loader.increase();

        Request.send({
            queue : [
                {
                    path : '/api/' + self._const.entities + '/' + self._state.item[self._const.id] + '_view',
                    data : {
                        info : 'params'
                    },
                },
                {
                    path : '/api/document_links'
                }
            ],
            done : function(response, extraResponse) {
                loader.decrease();
                Utils.scrollToTop();

                if(response.error) return;

                self._state.item = response[self._const.entity];
                self._state.documentLinks = extraResponse.data;

                self._setParamsFields();

                let $modal = new Modal({
                    title   : 'Настройка параметров',
                    content : Utils.renderProfileTemplate('form', {
                        item   : null,
                        entity : 'widget',
                        fields : self._state.paramsFields,
                        buttons: {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Сохранить',
                                type  : 'submit'
                            },
                            two : {
                                class : 'button--cancel',
                                title : 'Отмена'
                            }
                        }
                    }),
                    closingConfirmation : true,
                    dropzone : self._state.paramsDropzone,
                    confirm : function(args) {
                        self._bindParamsSubmit(args)
                    }
                });
            }
        })
    };

    _initCrm = () => {
        let self = this;

        const fields = {
            crm : {
                title    : 'CRM',
                type     : 'select',
                required : true,
                value    : '',
                options  : self._state.crms.filter(function(crm){ return crm.type == 'amo' }),
                name     : 'display_name',
                id       : 'id'
            }
        };

        let $modal = new Modal({
            title: 'Подключить CRM интеграцию',
            content: Utils.renderProfileTemplate('form', {
                item   : null,
                entity : self._const.entity,
                fields : fields,
                buttons: null
            }),
            closingConfirmation: false,
            confirm : function(args) {
                let $modal = args.modal;
                if (!$modal.length) return;
                let $form = $modal.find('form');
                if (!$form.length) return;

                loader.increase();

                Request.send({
                    path: '/api/' + self._const.entities + '/' + self._state.item.widget_id + '/attach/crm',
                    method: 'POST',
                    data: $form.serialize(),
                    done: function (response) {
                        loader.decrease();

                        if (response.error) {
                            //self.profile.callback.error(response.error, form, self.profile);
                            return
                        }

                        self._state.item = response[self._const.entity];
                        $modal.trigger('close');

                        self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                            crumbs : [
                                {
                                    title : 'Главная',
                                    href  : '#'
                                },
                                {
                                    title : 'Виджеты',
                                    href  : '#widgets'
                                },
                                {
                                    title : 'Виджет №' + self._state.item.widget_id
                                }
                            ],
                            dropdown : null,
                            activate : {
                                id        : self._state.item.widget_id,
                                is_active : self._state.item.is_active
                            }
                        });

                        self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                            breadcrumbs          : self._state.breadcrumbs,
                            [self._const.entity] : self._state.item
                        }));
                        self._bindElements();
                        self._bindUI();
                    }
                });
            }
        });

        let $form   = $modal.find('form');
        let $select = $form.find('select[name="widget[crm]"]');
        if (self._state.item.crms) {
            self._state.item.crms.forEach(function(crm){
                $select.children('option[value="' + crm.id + '"]').attr('disabled', 'disabled');
            });
        }
    };

    _initDocumentLink = () => {
        let self = this;

        let documentLinks = []
        self._state.document_links.forEach(dl => {
            documentLinks[dl.id] = {
                name : dl.name
            }
        })

        const fields = {
            confidential : {
                title    : 'Политика конфиденциальности',
                type     : 'select',
                required : true,
                value    : '',
                options  : documentLinks
            }
        };

        new Modal({
            title: 'Прикрепить политику конфиденциальности',
            content: Utils.renderProfileTemplate('form', {
                item   : null,
                entity : self._const.entity,
                fields : fields,
                buttons: null
            }),
            closingConfirmation: false,
            confirm : function(args) {
                let $modal = args.modal;
                if (!$modal.length) return;
                let $form = $modal.find('form');
                if (!$form.length) return;

                loader.increase();

                Request.send({
                    path: '/api/' + self._const.entities + '/' + self._state.item.widget_id + '/attach/document_link',
                    method: 'POST',
                    data: $form.serialize(),
                    done: function (response) {
                        loader.decrease();

                        if (response.error) {
                            console.log(response.error);
                            return
                        }

                        $modal.trigger('close');
                        self._init();
                    }
                });
            }
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$create    = self._elems.$content.find('.js-profile-widget-create');
        self._elems.$edit      = self._elems.$content.find('.js-profile-widget-edit');
        self._elems.$params    = self._elems.$content.find('.js-profile-widget-params-edit');
        self._elems.$crmAttach = self._elems.$content.find('.js-profile-crm-attach');
        self._elems.$crmDetach = self._elems.$content.find('.js-profile-crm-detach');

        self._elems.$documentLinkAttach = self._elems.$content.find('.js-profile-document-link-attach');
        self._elems.$documentLinkDetach = self._elems.$content.find('.js-profile-document-link-detach');
    };

    _bindSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        loader.increase();

        let validation = new Validation({
            form : $form
        });

        Request.send({
            path   : '/api/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item.widget_id + '/edit' : 'create'),
            method : 'POST',
            data   : $form.serialize(),

            done: function(response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return;
                }

                self._state.item  = response[self._const.entity];
                self._state.items = {};

                $modal.trigger('close');

                if(self._args.mode === Vars.view.index || self._args.mode === Vars.view.list) {
                    window.location.href = '#' + self._const.entities + '/' + self._state.item.widget_id;
                }
                else {
                    self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                        crumbs : [
                            {
                                title : 'Главная',
                                href  : '#'
                            },
                            {
                                title : 'Виджеты',
                                href  : '#widgets'
                            },
                            {
                                title : 'Виджет №' + self._state.item.widget_id
                            }
                        ],
                        dropdown : null,
                        activate : {
                            id        : self._state.item.widget_id,
                            is_active : self._state.item.is_active
                        }
                    });

                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                        breadcrumbs          : self._state.breadcrumbs,
                        [self._const.entity] : self._state.item
                    }));

                    self._bindElements();
                    self._bindUI();
                }
            }
        });
    };

    _bindActions = () => {
        let self = this;

        new Action({
            id       : self._state.item.widget_id,
            actions  : self._actions,
            entities : self._const.entities,
            entity   : self._const.entity,
            self     : self
        });
    };

    _bindFormActions = () => {
        let self = this;

        let $form = self._state.modal.find('form');

        if (!Object.keys(self._state.item).length) {
            $form.find('.form-field[data-name="widget-buildings"]').hide();
        }

        $form.find('select[name="widget[object]"]').change(function(){
            const val = parseInt($(this).val());
            $form.find('.form-field[data-name="widget-buildings"]').hide();
            $form.find('.form-field[data-name="widget-buildings"] > ul').each(function(){
                $(this).hide().removeClass('active');
                $(this).find('input[name="widget[building_all]"]').attr('disabled', 'disabled');
                $(this).find('input[name="widget[building_all]"]').parent().removeClass('checked');
                if (parseInt($(this).data('complex-id')) === val && $(this).children('ul > li').length){
                    $form.find('.form-field[data-name="widget-buildings"]').show();
                    $(this).show().addClass('active');
                    $(this).find('input[name="widget[building_all]"]').removeAttr('disabled');
                    $(this).find('input[name="widget[building_all]"]').parent().addClass('checked').trigger('update', true);
                }
            });

            let $option = $(this).children('[value="' + val + '"]');
            let $partsSelect = $form.find('select[name="widget[site_part]"]');
            if ($option.data('parts') !== undefined && $option.data('parts') != ''){
                $partsSelect.children('option').attr('disabled', 'disabled');
                const parts = $option.data('parts').toString().split(',');
                for (let i = 0; i < parts.length; i++){
                    $partsSelect.children('option[value="' + parts[i] + '"]').removeAttr('disabled');
                }
            }  else {
                $partsSelect.children('option').removeAttr('disabled');
            }
        });

        let $option = $form.find('select[name="widget[object]"]').children(':selected');
        let $partsSelect = $form.find('select[name="widget[site_part]"]');
        if ($option.data('parts') !== undefined && $option.data('parts') !== ''){
            $partsSelect.children('option').attr('disabled', 'disabled');
            const parts = $option.data('parts').toString().split(',');
            for (let i = 0; i < parts.length; i++){
                $partsSelect.children('option[value="' + parts[i] + '"]').removeAttr('disabled');
            }
        } else {
            $partsSelect.children('option').removeAttr('disabled');
        }

        $form.find('select[name="widget[site_part]"]').change(function(){
            const val = parseInt($(this).val());
            if (val === 1){
                $form.find('.facade-minicolors').parent().slideDown();
                $form.find('.facade-minicolors .minicolors-input').each(function(){
                    $(this).attr('required', 'required').removeAttr('disabled');
                });
                $form.find('input[name="widget[if_stroke_width]"]').attr('required', 'required').removeAttr('disabled');
            }
            else {
                $form.find('.facade-minicolors').parent().slideUp();
                $form.find('.facade-minicolors .minicolors-input').each(function () {
                    $(this).removeAttr('required').attr('disabled', 'disabled');
                });
                $form.find('input[name="widget[if_stroke_width]"]').removeAttr('required').attr('disabled', 'disabled');
            }
            if (val === 4) {
                $form.find('.chess-minicolors').parent().slideDown();
                $form.find('.chess-minicolors .minicolors-input').each(function(){
                    $(this).attr('required', 'required').removeAttr('disabled');
                });
            } else {
                $form.find('.chess-minicolors').parent().slideUp();
                $form.find('.chess-minicolors .minicolors-input').each(function () {
                    $(this).removeAttr('required').attr('disabled', 'disabled');
                });
            }
            $form.find('select[name="widget[color]"]').trigger('change');
        });

        $form.find('select[name="widget[color]"]').change(function(){
            let $select = $(this);
            let $option = $select.children(':selected');
            $form.find('input[name="widget[color_1]"]').minicolors('value', $option.data('color_1'));
            $form.find('input[name="widget[color_2]"]').minicolors('value', $option.data('color_2'));
            $form.find('input[name="widget[color_3]"]').minicolors('value', $option.data('color_3'));
            $form.find('input[name="widget[color_4]"]').minicolors('value', $option.data('color_4'));
            $form.find('input[name="widget[if_color_1]"]').minicolors('value', $option.data('if_color_1'));
            $form.find('input[name="widget[if_color_2]"]').minicolors('value', $option.data('if_color_2'));
            $form.find('input[name="widget[if_color_3]"]').minicolors('value', $option.data('if_color_3'));
            $form.find('input[name="widget[if_color_4]"]').minicolors('value', $option.data('if_color_4'));
            $form.find('input[name="widget[chess_color_1]"]').minicolors('value', $option.data('chess_color_1'));
            $form.find('input[name="widget[chess_color_2]"]').minicolors('value', $option.data('chess_color_2'));
            $form.find('input[name="widget[chess_color_3]"]').minicolors('value', $option.data('chess_color_3'));
            $form.find('input[name="widget[chess_color_4]"]').minicolors('value', $option.data('chess_color_4'));
            $form.find('select[name="widget[if_stroke_width]"]').val(2);
        });

        $form.find('.minicolors').each(function(){
            if ($(this).attr('name').indexOf('chess') != -1) {
                $(this).minicolors({
                    format: 'rgb'
                });
            }
            else {
                $(this).minicolors({
                    format: 'rgb',
                    opacity: true
                });
            }
        });

        $form.find('input.minicolors').change(function(){
            let $select = $form.find('select[name="widget[color]"]');
            let $option = $select.children(':selected');
            let $input  = $(this);
            if ($option.data($input.data('name')) === undefined)
                $select.val(1);

            $option = $select.children(':selected');
            if ($option.data($input.data('name')) !== undefined && $option.data($input.data('name')).replace(/\s/g, '') != $input.val().replace(/\s/g, '')){
                $select.children('option[value=1]').data($input.data('name'), $input.val().replace(/\s/g, ''));
                $select.val(1);
            }
        });
    };

    _bindCreateMax = () => {
        let self = this;

        const count = parseInt(self._elems.$create.data('count'));
        const max   = parseInt(self._elems.$create.data('max'));

        if (count < max && max != 0) return true;

        if (max == 0) {
            new Modal({
                title: ifacade.constants.messages.widgets.access.max.title,
                content: Utils.renderProfileTemplate('info', {
                    message : ifacade.constants.messages.widgets.access.start.message,
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Тарифы'
                        },
                        two : null
                    }
                }),
                confirm : function(args) {
                    args.modal && args.modal.trigger('close');
                    window.location.href = '#tariffs';
                }
            });

            return false;
        }

        new Modal({
            title: ifacade.constants.messages.widgets.access.max.title,
            content: Utils.renderProfileTemplate('info', {
                message : ifacade.constants.messages.widgets.access.max.message.replace('%max%', max),
                buttons : {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Хорошо'
                    },
                    two : null
                }
            }),
            confirm : function(args) {
                args.modal && args.modal.trigger('close');
            }
        });

        return false;
    };

    _bindCrm = () => {
        let self = this;

        self._elems.$crmAttach.length && self._elems.$crmAttach.unbind('click').on('click', function(e) {
            e.preventDefault();

            loader.increase();

            Request.send({
                path: '/api/crms',
                done: function (response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._state.crms = response.crms;
                    self._initCrm();
                }
            });
        });

       self._elems.$crmDetach.length && self._elems.$crmDetach.unbind('click').on('click', function(e) {
            e.preventDefault();

            const id = $(this).data('id');

           let $modal = new Modal({
               title: 		'Открепить интеграцию?',
               content: 	Utils.renderProfileTemplate('info', {
                   message : '',
                   buttons : {
                       one : {
                           class : 'confirm button--edit',
                           title : 'Открепить'
                       },
                       two : {
                           class : 'button--cancel',
                           title : 'Отмена'
                       }
                   }
               }),
               confirm : function(args) {
                   let $nmodal = args.modal;

                   loader.increase();

                   Request.send({
                       path: '/api/' + self._const.entities + '/' + self._state.item.widget_id + '/detach/crm',
                       method: 'POST',
                       data: {
                           widget : {
                               crm : id
                           }
                       },
                       done: function (response) {
                           loader.decrease();

                           if (response.error) {
                               // self.profile.callback.error(response.error, form, self.profile);
                               return
                           }

                           self._state.item = response[self._const.entity];
                           $nmodal.trigger('close');

                           self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                               breadcrumbs          : self._state.breadcrumbs,
                               [self._const.entity] : self._state.item
                           }));
                           self._bindElements();
                           self._bindUI();
                       }
                   });
               }
           });
        });
    };

    _bindDocumentLink = () => {
        let self = this;

        self._elems.$documentLinkAttach.length && self._elems.$documentLinkAttach.unbind('click').on('click', function(e) {
            e.preventDefault();

            loader.increase();

            Request.send({
                path: '/api/document_links',
                done: function (response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._state.document_links = response.data;
                    self._initDocumentLink();
                }
            });
        });

        self._elems.$documentLinkDetach.length && self._elems.$documentLinkDetach.unbind('click').on('click', function(e) {
            e.preventDefault();

            new Modal({
                title: 		'Открепить документ?',
                content: 	Utils.renderProfileTemplate('info', {
                    message : '',
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Открепить'
                        },
                        two : {
                            class : 'button--cancel',
                            title : 'Отмена'
                        }
                    }
                }),
                confirm : function(args) {
                    let $nmodal = args.modal;

                    loader.increase();

                    Request.send({
                        path: '/api/' + self._const.entities + '/' + self._state.item.widget_id + '/detach/document_link',
                        method: 'POST',
                        done: function (response) {
                            loader.decrease();

                            if (response.error) {
                                // self.profile.callback.error(response.error, form, self.profile);
                                return
                            }

                            $nmodal.trigger('close');
                            self._init();
                        }
                    });
                }
            });
        });
    };

    _bindParamsSubmit = (args) => {
        let self = this;

        loader.increase();

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._state.item[self._const.id] + '/edit/params',
            method: 'POST',
            data: $form.serialize(),
            done: function (response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return
                }

                $modal.trigger('close');
                self._item();
            }
        });
    };

    _bindUI = () => {
        let self = this;

        self._elems.$create.length && self._elems.$create.unbind('click').on('click', function(e) {
            e.preventDefault();

            if (!self._bindCreateMax()) return;

            self._initModal();
        });

        self._elems.$edit.length && self._elems.$edit.unbind('click').on('click', function(e) {
            e.preventDefault();
            self._initModal();
        });

        self._elems.$params.length && self._elems.$params.unbind('click').on('click', function(e) {
            e.preventDefault();
            self._initParams();
        });

        self._bindActions();
        self._bindCrm();
        self._bindDocumentLink();
    };

    _index = () => {
        let self = this;
        self._bindElements();
        self._bindUI();
    };

    _list = () => {
        let self = this;

        self._bindElements();

        Request.send({
            queue: [
                {
                    path: '/api/' + self._const.entities
                },
                {
                    path: '/api/counts?only=objects'
                },
                {
                    path: '/api/accesses?only=' + self._const.entities
                }
            ],
            done: function(response, extraResponse, extraResponse1) {
                loader.decrease();
                Utils.scrollToTop();

                const accesses      = extraResponse1.accesses;

                self._state.items   = response[self._const.entities] ? response[self._const.entities] : {};
                const counts        = extraResponse.counts ? extraResponse.counts : [];
                const objects       = Object.keys(counts).length && counts.objects ? counts.objects : 0;
                const objectsShared = Object.keys(counts).length && counts.rights && counts.rights.objects ? counts.rights.objects : 0;

                self._state.objects = objects + objectsShared;

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs            : self._state.breadcrumbs,
                    [self._const.entities] : self._state.items,
                    objects                : self._state.objects,
                    accesses               : accesses
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _item = () => {
        let self = this;

        self._bindElements();

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._args.prefix + '_' + self._args.suffix  + '_view',
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                if (response.error) {
                    window.location.href = '/profile#' + self._const.entities;
                    return;
                }

                self._state.item     = response[self._const.entity];

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Виджеты',
                            href  : '#widgets'
                        },
                        {
                            title : 'Виджет №' + self._state.item.widget_id
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.widget_id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;

        if (self._args.mode === Vars.view.index) {
            self._index();
        } else if (self._args.mode === Vars.view.list) {
            self._list();
        } else if (self._args.mode === Vars.view.item) {
            self._item();
        }
    };
}

export default Widget;